import api from './api';
import { BannerResponse, SingleBannerResponse } from '../types/banner';

export const getBanners = async (params?: {
    page?: number;
    limit?: number;
    sortBy?: string;
    sortOrder?: 'ASC' | 'DESC';
}): Promise<BannerResponse> => {
    const response = await api.get('/banners', { params });
    return response.data;
};

export const uploadBanner = async (file: File): Promise<SingleBannerResponse> => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/banners', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const toggleActive = async (id: string): Promise<SingleBannerResponse> => {
    const response = await api.patch(`/banners/${id}/toggle-active`);
    return response.data;
};

export const updateSortOrder = async (id: string, sortOrder: number): Promise<SingleBannerResponse> => {
    const response = await api.patch(`/banners/${id}/sort-order`, { sortOrder });
    return response.data;
};

export const deleteBanner = async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/banners/${id}`);
    return response.data;
};
